// Shared rules for the published room notice and future moderation work.
// This copy does not claim that an automated moderator is already running.
export const roomGuidelines = {
  heading: 'Keep it kind. Keep it about the show.',
  body: 'No hate speech, harassment, threats, doxxing, or spam. Never share someone’s private personal information. Critique the drama—not someone’s identity. Rule-breaking messages may be removed and accounts restricted.',
  timing: 'Member chat opens 1 hour before showtime and closes 1 hour after the show ends.',
} as const
